import { render, staticRenderFns } from "./DashboardResponseTime.vue?vue&type=template&id=463d5eaf"
import script from "./DashboardResponseTime.vue?vue&type=script&lang=js"
export * from "./DashboardResponseTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports